import React, { forwardRef } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import StyledInput from './styled'
import CloseWrapper from '../../close-wrapper'

const InputBase = forwardRef((props, ref) => {
  const {
    // 类型
    type,
    name,
    // 样式类
    className,
    style,
    // 值
    value,
    defaultValue,
    placeholder,
    resetVal = { target: { value: '' } },
    // 状态
    disabled,
    readonly,
    autoComplete,
    autofocus,
    // 校验设置
    max,
    min,
    maxLength,
    minLength,
    // 事件类
    onChange,
    onFocus,
    onBlur,
    onPressEnter,
    allowClear = true,
    ...otherProps
  } = props
  const onClear = () => {
    onChange(resetVal)
  }

  return (
    <CloseWrapper allowClear={readonly ? false : allowClear} onClear={onClear}>
      <StyledInput
        type={type}
        name={name}
        ref={ref}
        className={clsx(
          'form-input dark:bg-transparent dark:focus:border-primary-700 dark:dark-form-input dark:text-white',
          className,
          readonly && 'text-gray-400'
        )}
        style={style}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        readOnly={readonly}
        disabled={disabled}
        autoComplete={autoComplete}
        // eslint-disable-next-line react/no-unknown-property
        autoFocus={autofocus}
        max={max}
        min={min}
        maxLength={maxLength}
        minLength={minLength}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            if (onPressEnter) {
              onPressEnter(event)
            }
          }
        }}
        {...otherProps}
      />
    </CloseWrapper>
  )
})

InputBase.propTypes = {
  type: PropTypes.oneOf([
    'text',
    'password',
    'number',
    'email',
    'url',
    'tel',
    'identifier',
  ]),
  name: PropTypes.string,
  className: PropTypes.string,
  // style: PropTypes.shape(PropTypes.object),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autoComplete: PropTypes.string,
  autofocus: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onPressEnter: PropTypes.func,
}

InputBase.defaultProps = {
  type: 'text',
  name: undefined,
  className: undefined,
  // style: {},
  value: undefined,
  defaultValue: undefined,
  placeholder: undefined,
  max: undefined,
  min: undefined,
  maxLength: undefined,
  minLength: undefined,
  disabled: false,
  readonly: false,
  autoComplete: 'on',
  autofocus: undefined,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onPressEnter: () => {},
}

export default InputBase
